export default {
  unknown_user: 'Please log in',
  settings: 'Settings',
  logout: 'Logout',
  login: 'Login',
  light: 'Light theme',
  dark: 'Dark theme',
  scrollOffNavbarOff: 'Keep navbar on scroll',
  scrollOffNavbarOn: 'Remove navbar on scroll',
  disconnected_message: 'You are disconnected.',
};
